import url from '@paybis/frontend-common-lib/src/services/url';
import { i18n } from '@/i18n';

function generate(uri: string, params: Record<string, string> = {}): string {
  return url.generate(uri, params, i18n.locale);
}

export function useUrl() {
  return { generate };
}
